import React from "react";
import Form24QFilingPanel from "../Form24QFilingPanel";
import StatutoryContributionStatementPanel from "./StatutoryContributionStatementPanel";
import BenefitRemittancePanel from "./BenefitRemittancePanel";

export default function PayrollStatutoryFilingPanel({
  activeSubTab = "pf",
  darkMode = false,
  canViewForm24Q = false,
}) {
  if (activeSubTab === "form-24q") {
    if (!canViewForm24Q) {
      return (
        <div className="ds-page-panel p-6">
          <p className="text-sm text-[hsl(var(--ds-muted-fg))]">
            You do not have access to Form 24Q Filing.
          </p>
        </div>
      );
    }
    return (
      <div className="flex h-full min-h-0 flex-col overflow-hidden p-4">
        <Form24QFilingPanel darkMode={darkMode} />
      </div>
    );
  }

  if (activeSubTab === "nps" || activeSubTab === "meal") {
    return (
      <div className="flex h-full min-h-0 flex-col overflow-hidden p-4">
        <BenefitRemittancePanel kind={activeSubTab} darkMode={darkMode} />
      </div>
    );
  }

  if (activeSubTab === "pf" || activeSubTab === "esi" || activeSubTab === "pt") {
    return (
      <div className="flex h-full min-h-0 flex-col overflow-hidden p-4">
        <StatutoryContributionStatementPanel kind={activeSubTab} darkMode={darkMode} />
      </div>
    );
  }

  return (
    <div className="ds-page-panel p-6">
      <p className="text-sm text-[hsl(var(--ds-muted-fg))]">Unknown statutory filing tab.</p>
    </div>
  );
}
